import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { ChangeEmailFormPost } from "../../forms/ChangeEmailForm"

import * as Styled from "./AccountSettingsEmailPage.styled"

export const AccountSettingsEmailPage = (props) => {
    const {
        onSuccess,
    } = props

    const isMobile = useIsMobileDevice()

    return (
        <Styled.Content isMobile={isMobile}>
            <ChangeEmailFormPost onSuccess={onSuccess} />
        </Styled.Content>
    )
}